import axios from 'components/Axios';
import { Comment, CommentReply } from '../APIEndPoint';

const AddComment = (payload) => {
  const promise = axios.post(`${Comment}`, payload);
  const dataPromise = promise.then((response) => response.data);
  return dataPromise;
};
const AddCommentsReply = (payload) => {
  const promise = axios.post(CommentReply, payload);
  const dataPromise = promise.then((response) => response.data);
  return dataPromise;
};

const GetCommentById = (payload, currentTime, page, size, userId) => {
  const promise = axios.get(
    `comments/byPostId/${payload}?interactionTime=${currentTime}&size=${
      size || 30
    }&page=${page || 0}&userId=${userId}&clientOffSet=${new Date().getTimezoneOffset()}`
  );
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const DeleteCommentsReply = (id, type) => {
  const promise = axios.delete(`${type}/${id}`);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

export { AddComment, GetCommentById, AddCommentsReply, DeleteCommentsReply };
